import './registrationDetailsHit.css'
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { UPLOAD_DCUMENT, authKey, UPDATE_GROWER, ResourceUpdateMember } from '../../../../common/URLs'
import moment from 'moment';
import { ADD_POPOVER, API_DATE_FORMAT, BASIC_DATE_FORMAT, CANCEL_POPOVER, EMPTY_FIELD_ERROR, SUBMIT_API, UPDATE_POPOVER, UPLOAD_FILE_TEXT, VEHICLE_INSURANCE, VEHICLE_NATIONAL_PERMIT, VEHICLE_PUCC, WEIGHT_ERROR } from '../../../../common/constants';
// import { Col, Container, Row, Stack } from 'react-bootstrap';
import { VALIDATION } from '../../../../common/commonValidations';
// import { FileUpload } from "../../../../common/fileUpload/fileUpload";
import { FileUploadMUI } from '../../../../common/fileUpload/fileUploadMUI';
import { PROD } from '../../../../common/constants';
import { Container, Card, Button, CardContent, RadioGroup, Radio, FormGroup, FormLabel, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { v4 as uuidv4 } from 'uuid';
import { useTranslation } from 'react-i18next';
import { handleNumberFieldFocus } from '../../../../common/commonFunction';

export const VehiclePopupHit = (props) => {
    const { t } = useTranslation();
    const [documentsArray, setDocumentsArray] = useState(props.vehicleItem ? props.vehicleItem.documents : []);
    const [errorMessage, setErrorMessage] = useState({
        vehicleWeightErr: '',
        unladenWeightErr: '',
        vehicleMakeErr: '',
        vehicleModelErr: '',
        vehicleAgeErr: '',
        registrationNumberErr: '',
        insuranceNumberErr: '',
        puccNumberErr: '',
        fitnessNumberErr: '',
        documentError: '',
        registrationDocError: '',
        insurenaceDocError: '',
        puccDocError: '',
        fitnessDocError: ''
    });
    const [vehicleDetail, setVehicleDetail] = useState(
        {
            id: props.vehicleItem ? props.vehicleItem.id : uuidv4(),
            regHitMasterId: props?.regStakeholderMaster?.id,
            vehicleType: props.vehicleItem ? props.vehicleItem.vehicleType : 'HCV',
            grossVehicleWeight: props.vehicleItem ? props.vehicleItem.grossVehicleWeight : null,
            unladenWeight: props.vehicleItem ? props.vehicleItem.unladenWeight : null,
            vehicleMake: props.vehicleItem ? props.vehicleItem.vehicleMake : null,
            vehicleModel: props.vehicleItem ? props.vehicleItem.vehicleModel : null,
            vehicleAge: props.vehicleItem ? props.vehicleItem.vehicleAge : null,
            insuranceNo: props.vehicleItem ? props.vehicleItem.insuranceNo : null,
            insuranceEnddate: props.vehicleItem ? props.vehicleItem.insuranceEnddate : moment(new Date()).format(API_DATE_FORMAT),
            registrationEndDate: props.vehicleItem ? props.vehicleItem.registrationEndDate : moment(new Date()).format(API_DATE_FORMAT),
            puccNo: props.vehicleItem ? props.vehicleItem.puccNo : null,
            puccEndDate: props.vehicleItem ? props.vehicleItem.puccEndDate : moment(new Date()).format(API_DATE_FORMAT),
            fitnessNo: props.vehicleItem ? props.vehicleItem.fitnessNo : null,
            fitnessEndDate: props.vehicleItem ? props.vehicleItem.fitnessEndDate : moment(new Date()).format(API_DATE_FORMAT),
            isNationalPermitAvailable: props.vehicleItem ? props.vehicleItem.isNationalPermitAvailable : null,
            nationalPermitEnddate: props.vehicleItem ? props.vehicleItem.nationalPermitEnddate : moment(new Date()).format(API_DATE_FORMAT),
            ownershipType: props.vehicleItem ? props.vehicleItem.ownershipType : 'Owned',
            registrationNo: props.vehicleItem ? props.vehicleItem.registrationNo : null,
            isActive: 1,
            createdOn: props.vehicleItem ? props.vehicleItem.createdOn : null,
            createdBy: props.vehicleItem ? props.vehicleItem.createdBy : null,
            updatedOn: props.vehicleItem ? props.vehicleItem.updatedOn : null,
            updatedBy: props.vehicleItem ? props.vehicleItem.updatedBy : null,
            documents: documentsArray,
        });
    let checkUserDetails = localStorage.getItem('role');

    const onUploadCallBack = (docArray) => {
        setDocumentsArray(docArray);
    }
    useEffect(() => {
        if (documentsArray) {
            setVehicleDetail({ ...vehicleDetail, documents: documentsArray })
        }
    }, [documentsArray]);

    const handleChange = (e) => {
        setVehicleDetail({ ...vehicleDetail, [e.target.name]: e.target.value });

        if (e.target.name === 'grossVehicleWeight') {
            const slicedValue = VALIDATION.weightsSlicedValue(e.target.value);
            const vehicleWeightValidation = VALIDATION.weightsValidation(vehicleDetail.vehicleType, slicedValue)
            setVehicleDetail({ ...vehicleDetail, [e.target.name]: slicedValue });
            if (slicedValue.length == 0) {
                setErrorMessage({ ...errorMessage, vehicleWeightErr: 'Please enter Vehicle weight' })
            }
            else if (vehicleWeightValidation) {
                setErrorMessage({ ...errorMessage, vehicleWeightErr: vehicleWeightValidation })
            }
            else setErrorMessage({ ...errorMessage, vehicleWeightErr: "" })
        }

        if (e.target.name === 'unladenWeight') {
            setVehicleDetail({ ...vehicleDetail, [e.target.name]: VALIDATION.weightsSlicedValue(e.target.value) });
            if ((e.target.value.toString()).length < 5) {
                setErrorMessage({ ...errorMessage, unladenWeightErr: '' })
            }
            //  else setErrorMessage({ ...errorMessage, unladenWeightErr: WEIGHT_ERROR })
        }

        if (e.target.name === 'vehicleMake') {
            if ((e.target.value.toString()).length > 0) {
                setVehicleDetail({ ...vehicleDetail, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 50)) });
                setErrorMessage({ ...errorMessage, vehicleMakeErr: '' })
            } else {
                setErrorMessage({ ...errorMessage, vehicleMakeErr: "Please enter Vehicle Make" })
            }
        }
        if (e.target.name === 'vehicleModel') {
            if ((e.target.value.toString()).length > 0) {
                setVehicleDetail({ ...vehicleDetail, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 50)) });
                setErrorMessage({ ...errorMessage, vehicleModelErr: '' })
            } else setErrorMessage({ ...errorMessage, vehicleModelErr: "Please enter Vehicle Model" })
        }
        if (e.target.name === 'vehicleAge') {
            if ((e.target.value.toString()).length > 0) {
                setVehicleDetail({ ...vehicleDetail, [e.target.name]: e.target.value.slice(0, 2) });
                setErrorMessage({ ...errorMessage, vehicleAgeErr: '' })
            } else setErrorMessage({ ...errorMessage, vehicleAgeErr: "Please enter Vehicle Age" })
        }
        if (e.target.name === 'registrationNo') {
            if ((e.target.value.toString()).length > 0) {
                if (VALIDATION.registrationNumberValidation(e.target.value)) {
                    setVehicleDetail({ ...vehicleDetail, [e.target.name]: VALIDATION.noSpecialCharCapsValidation(e.target.value.slice(0, 50)) });
                    if (props.addOrEdit === "edit" && props?.regStakeholderMaster?.hitVehicleDetails.filter(item => (item.registrationNo == (e.target.value))).length == 0) {

                        setErrorMessage({ ...errorMessage, registrationNumberErr: '' })
                    }
                    else if (props.addOrEdit === "add")
                        setErrorMessage({ ...errorMessage, registrationNumberErr: '' })
                    else setErrorMessage({ ...errorMessage, registrationNumberErr: ' Registration Number already exists' })

                } else setErrorMessage({ ...errorMessage, registrationNumberErr: 'Please enter valid Registration Number' })

            } else setErrorMessage({ ...errorMessage, registrationNumberErr: 'Please enter valid Registration Number' })
        }
        if (e.target.name === 'insuranceNo') {
            if ((e.target.value.toString()).length > 0) {
                setErrorMessage({ ...errorMessage, insuranceNumberErr: '' })
                setVehicleDetail({ ...vehicleDetail, [e.target.name]: VALIDATION.noSpecialCharCapsValidation(e.target.value.slice(0, 50)) });
            } else setErrorMessage({ ...errorMessage, insuranceNumberErr: 'Please enter valid Insurance No.' })
        }
        if (e.target.name === 'puccNo') {
            if ((e.target.value.toString()).length > 0) {
                setErrorMessage({ ...errorMessage, puccNumberErr: '' })
                setVehicleDetail({ ...vehicleDetail, [e.target.name]: VALIDATION.noSpecialCharCapsValidation(e.target.value.slice(0, 50)) });
            } else setErrorMessage({ ...errorMessage, puccNumberErr: 'Please enter valid PUCC No.' })
        }
        if (e.target.name === 'fitnessNo') {
            if ((e.target.value.toString()).length > 0) {
                setErrorMessage({ ...errorMessage, fitnessNumberErr: '' })
                setVehicleDetail({ ...vehicleDetail, [e.target.name]: VALIDATION.noSpecialCharCapsValidation(e.target.value.slice(0, 50)) });
            } else setErrorMessage({ ...errorMessage, fitnessNumberErr: 'Please enter valid Fitness No.' })
        }
    };
    const handleDateChange = (e, name) => {
        const newDate = e.format(API_DATE_FORMAT);
        setVehicleDetail({ ...vehicleDetail, [name]: newDate })
    }
    const onValidationCheck = (e) => {
        let vehicleWeightValidation = VALIDATION.weightsValidation(vehicleDetail.vehicleType, vehicleDetail.grossVehicleWeight)
        let vehiceReg = documentsArray && documentsArray.filter((item) => item.documentType === "VehicleRegistration" && (item.isActive == 1 || item.isActive == 3));
        let insurance = documentsArray && documentsArray.filter((item) => item.documentType === "VehicleInsurance" && (item.isActive == 1 || item.isActive == 3));
        let pucc = documentsArray && documentsArray.filter((item) => item.documentType === "VehiclePUCC" && (item.isActive == 1 || item.isActive == 3));
        let fitness = documentsArray && documentsArray.filter((item) => item.documentType === "FitnessNo" && (item.isActive == 1 || item.isActive == 3));

        if (!vehicleDetail.grossVehicleWeight || (vehicleDetail.grossVehicleWeight.toString()).length == 0) {
            setErrorMessage({ ...errorMessage, vehicleWeightErr: "Please enter Vehicle Weight" })
            return;
        }
        else if (vehicleWeightValidation) {
            setErrorMessage({ ...errorMessage, vehicleWeightErr: vehicleWeightValidation })
            return;
        }
        else if (!vehicleDetail.unladenWeight || (vehicleDetail.unladenWeight.toString()).length == 0) {
            setErrorMessage({ ...errorMessage, unladenWeightErr: "Please enter Unladen Weight" })
            return;
        }
        else if (!vehicleDetail.vehicleMake || vehicleDetail.vehicleMake.length == 0) {
            setErrorMessage({ ...errorMessage, vehicleMakeErr: "Please enter Vehicle Make" })
            return;
        }
        else if (!vehicleDetail.vehicleModel || vehicleDetail.vehicleModel.length == 0) {
            setErrorMessage({ ...errorMessage, vehicleModelErr: "Please enter Vehicle Model" })
            return;
        }
        else if (!vehicleDetail.vehicleAge || (vehicleDetail.vehicleAge.toString()).length == 0) {
            setErrorMessage({ ...errorMessage, vehicleAgeErr: "Please enter Vehicle Age" })
            return;
        }
        else if (!vehicleDetail.registrationNo || vehicleDetail.registrationNo.length == 0) {
            setErrorMessage({ ...errorMessage, registrationNumberErr: 'Please enter valid Registration Number' })
            return;
        }
        else if (vehiceReg.length == 0) {
            setErrorMessage({ registrationDocError: "Please upload vehicle registration document" });
            return;
        }
        else if (!vehicleDetail.insuranceNo || vehicleDetail.insuranceNo.length == 0) {
            setErrorMessage({ ...errorMessage, insuranceNumberErr: 'Please enter valid Insurance No.' })
            return;
        }
        else if (insurance.length == 0) {
            setErrorMessage({ insurenaceDocError: "Please upload vehicle insurance document" });
            return;
        }
        else if (!vehicleDetail.puccNo || vehicleDetail.puccNo.length == 0) {
            setErrorMessage({ ...errorMessage, puccNumberErr: 'Please enter valid PUCC No.' })
            return;
        }
        else if (pucc.length == 0) {
            setErrorMessage({ puccDocError: "Please upload vehicle pucc document" });
            return;
        }
        else if (!vehicleDetail.fitnessNo || vehicleDetail.fitnessNo.length == 0) {
            setErrorMessage({ ...errorMessage, fitnessNumberErr: 'Please enter valid Fitness No.' })
            return;
        }
        else if (fitness.length == 0) {
            setErrorMessage({ fitnessDocError: "Please upload vehicle fitness document" });
            return;
        }
        else if (props.addOrEdit === "edit" && errorMessage.registrationNumberErr.length > 0) {
            setErrorMessage({ ...errorMessage, registrationNumberErr: ' Registration Number already exists' })
            return;
        }
        else if (props.addOrEdit === "add" && props?.regStakeholderMaster?.hitVehicleDetails.filter(item => (item.registrationNo === vehicleDetail.registrationNo)).length > 0) {
            setErrorMessage({ ...errorMessage, registrationNumberErr: ' Registration Number already exists' })
            return;
        }
        else {
            props.vehicleSubmitCallbackFunction(vehicleDetail, props.onClose, props.addOrEdit)
        }

    }

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG25</p>}
                <Typography variant="h5" gutterBottom>
                    {t('reg.vehicleDetails')}
                </Typography>
                <Grid container spacing={2} direction="row" mt={1}>
                    <Grid item xs={12} lg={4}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <FormControl fullWidth required>
                                    <FormLabel>{t('reg.type')}</FormLabel>
                                    <RadioGroup row>
                                        <FormControlLabel control={<Radio id="hcv" disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false} name="vehicleType" value="HCV" checked={vehicleDetail?.vehicleType === "HCV"} onChange={(e) => handleChange(e)} />} label={t('preReg.hcv')} />
                                        <FormControlLabel control={<Radio id="mcv" disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false} name="vehicleType" value="MCV" checked={vehicleDetail?.vehicleType === "MCV"} onChange={(e) => handleChange(e)} />} label={t('preReg.mcv')} />
                                        <FormControlLabel control={<Radio id="lcv" name="vehicleType" disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false} value="LCV" checked={vehicleDetail?.vehicleType === "LCV"} onChange={(e) => handleChange(e)} />} label={t('preReg.lcv')} />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth required>
                                    <FormLabel>{t('preReg.ownnershipType')}</FormLabel>
                                    <RadioGroup row>
                                        <FormControlLabel control={<Radio id="Owned" disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false} name="ownershipType" value="Owned" checked={vehicleDetail?.ownershipType === "Owned"} onChange={(e) => handleChange(e)} />} label={t('preReg.owned')} />
                                        <FormControlLabel control={<Radio id="Rented" disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false} name="ownershipType" value="Rented" checked={vehicleDetail?.ownershipType === "Rented"} onChange={(e) => handleChange(e)} />} label={t('preReg.rented')} />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField fullWidth error={errorMessage.vehicleWeightErr} helperText={errorMessage.vehicleWeightErr} required type="number" onFocus={handleNumberFieldFocus} disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false} label={t('reg.grossVehicleWeight')} name="grossVehicleWeight" value={vehicleDetail?.grossVehicleWeight} onChange={(e) => handleChange(e)} inputProps={{
                                    maxLength: 10
                                }} />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField fullWidth required error={errorMessage.unladenWeightErr} helperText={errorMessage.unladenWeightErr} type="number" onFocus={handleNumberFieldFocus} label={t('reg.unladenWeight')} name="unladenWeight" value={vehicleDetail?.unladenWeight} disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false} onChange={(e) => handleChange(e)} inputProps={{
                                    maxLength: 10
                                }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth required error={errorMessage.vehicleMakeErr} helperText={errorMessage.vehicleMakeErr} type="text" label={t('reg.vehicleMake')} disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false} name="vehicleMake" value={vehicleDetail?.vehicleMake} onChange={(e) => handleChange(e)} inputProps={{
                                    maxLength: 20
                                }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth required error={errorMessage.vehicleModelErr} helperText={errorMessage.vehicleModelErr} type="text" label={t('reg.vehicleModel')} name="vehicleModel" disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false} value={vehicleDetail?.vehicleModel} onChange={(e) => handleChange(e)} inputProps={{
                                    maxLength: 20
                                }} />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField fullWidth required error={errorMessage.vehicleAgeErr} helperText={errorMessage.vehicleAgeErr} type="number" onFocus={handleNumberFieldFocus} label={t('reg.vehicleAgeInYears')} name="vehicleAge" disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false} value={vehicleDetail?.vehicleAge} onChange={(e) => handleChange(e)} inputProps={{
                                    maxLength: 5
                                }} />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <TextField fullWidth required error={errorMessage.registrationNumberErr} helperText={errorMessage.registrationNumberErr} disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false} style={{ textTransform: 'uppercase' }} type="text" label={t('reg.registrationNo')} placeholder="Eg: AS01BYXXXX." name="registrationNo" value={vehicleDetail?.registrationNo} onChange={(e) => handleChange(e)} inputProps={{
                                    maxLength: 20,
                                    style: { textTransform: "uppercase" }
                                }} />
                                <FileUploadMUI key="VehicleRegistration"
                                    documentList={documentsArray}
                                    documentType="VehicleRegistration"
                                    callBackDocumentUpload={onUploadCallBack}
                                    stakeholderDetailId={vehicleDetail.id}
                                    title={t('reg.uploadVehicleRegistrationDoc')}
                                    stakeHolderType="hit"
                                    errorMessage={errorMessage}
                                    setErrorMessage={setErrorMessage}
                                    documentError="registrationDocError"
                                />
                                {/* <div className='mandatory_field'>{errorMessage.registrationDocError}</div> */}
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            inputFormat="DD/MM/YYYY"
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{ minWidth: 750 }}
                                            label={t('reg.validTill')}
                                            minDate={moment(new Date()).format(API_DATE_FORMAT)}
                                            name="registrationEndDate"
                                            value={vehicleDetail.registrationEndDate ? moment(new Date((vehicleDetail.registrationEndDate))).format(BASIC_DATE_FORMAT) : moment(new Date).format(BASIC_DATE_FORMAT)}
                                            onChange={(e) => handleDateChange(e, "registrationEndDate")}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth required error={errorMessage.insuranceNumberErr} helperText={errorMessage.insuranceNumberErr} type="text" label={t('reg.insuranceNo')} name="insuranceNo" value={vehicleDetail?.insuranceNo} onChange={(e) => handleChange(e)} inputProps={{
                                    maxLength: 20,
                                    style: { textTransform: "uppercase" }
                                }} />
                                <FileUploadMUI key="VehicleInsurance"
                                    documentList={documentsArray}
                                    documentType="VehicleInsurance"
                                    callBackDocumentUpload={onUploadCallBack}
                                    stakeholderDetailId={vehicleDetail.id}
                                    title={t('reg.uploadInsuranceDoc')}
                                    stakeHolderType="hit"
                                    errorMessage={errorMessage}
                                    setErrorMessage={setErrorMessage}
                                    documentError="insurenaceDocError"
                                />
                                {/* <div className='mandatory_field'>{errorMessage.insurenaceDocError}</div> */}
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            inputFormat="DD/MM/YYYY"
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{ minWidth: 750 }}
                                            label={t('reg.validTill')}
                                            name="insuranceEnddate"
                                            minDate={moment(new Date()).format(API_DATE_FORMAT)}
                                            value={vehicleDetail.insuranceEnddate ? moment(new Date((vehicleDetail.insuranceEnddate))).format(BASIC_DATE_FORMAT) : moment(new Date).format(BASIC_DATE_FORMAT)}
                                            onChange={(e) => handleDateChange(e, "insuranceEnddate")}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth required error={errorMessage.puccNumberErr} helperText={errorMessage.puccNumberErr} type="text" label={t('reg.puccNo')} name="puccNo" value={vehicleDetail?.puccNo} onChange={(e) => handleChange(e)} inputProps={{
                                    maxLength: 20,
                                    style: { textTransform: "uppercase" }
                                }} />
                                <FileUploadMUI key="VehiclePUCC"
                                    documentList={documentsArray}
                                    documentType="VehiclePUCC"
                                    callBackDocumentUpload={onUploadCallBack}
                                    stakeholderDetailId={vehicleDetail.id}
                                    title={t('reg.uploadPuccDoc')}
                                    stakeHolderType="hit"
                                    errorMessage={errorMessage}
                                    setErrorMessage={setErrorMessage}
                                    documentError="puccDocError"
                                />
                                {/* <div className='mandatory_field'>{errorMessage.puccDocError}</div> */}
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            inputFormat="DD/MM/YYYY"
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{ minWidth: 750 }}
                                            name="puccEndDate"
                                            label={t('reg.validTill')}
                                            minDate={moment(new Date()).format(API_DATE_FORMAT)}
                                            value={vehicleDetail.puccEndDate ? moment(new Date((vehicleDetail.puccEndDate))).format(BASIC_DATE_FORMAT) : moment(new Date).format(BASIC_DATE_FORMAT)}
                                            onChange={(e) => handleDateChange(e, "puccEndDate")}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth required error={errorMessage.fitnessNumberErr} helperText={errorMessage.fitnessNumberErr} type="text" label={t('reg.fitnessNo')} name="fitnessNo" value={vehicleDetail?.fitnessNo} onChange={(e) => handleChange(e)} inputProps={{
                                    maxLength: 20,
                                    style: { textTransform: "uppercase" }
                                }} />
                                <FileUploadMUI key="FitnessNo"
                                    documentList={documentsArray}
                                    documentType="FitnessNo"
                                    callBackDocumentUpload={onUploadCallBack}
                                    stakeholderDetailId={vehicleDetail.id}
                                    title={t('reg.uploadFitnessDoc')}
                                    stakeHolderType="hit"
                                    errorMessage={errorMessage}
                                    setErrorMessage={setErrorMessage}
                                    documentError="fitnessDocError"
                                />
                                {/* <div className='mandatory_field'>{errorMessage.fitnessDocError}</div> */}
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            inputFormat="DD/MM/YYYY"
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{ minWidth: 750 }}
                                            minDate={moment(new Date()).format(API_DATE_FORMAT)}
                                            name="fitnessEndDate"
                                            label={t('reg.validTill')}
                                            value={vehicleDetail.fitnessEndDate ? moment(new Date((vehicleDetail.fitnessEndDate))).format(BASIC_DATE_FORMAT) : moment(new Date).format(BASIC_DATE_FORMAT)}
                                            onChange={(e) => handleDateChange(e, "fitnessEndDate")}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
            <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                <Button sx={{ minWidth: 100 }} variant="contained" onClick={props.onClose}>{t('reg.cancel')}</Button>
                <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={(e) => onValidationCheck(e)}>{props.addOrEdit === 'add' ? t('reg.add') : t('reg.update')}</Button>
            </Box>
        </>
    )

}